import { hasAuthParams, useAuth } from 'react-oidc-context';
import { useEffect, useState } from 'react';
import i18next from 'i18next';
import moment from 'moment';

import API from '@/shared/api/ApiService';
import { LanguageCode } from '~/common/enums';

import migrateLegacyLocalStorage from '@/shared/hooks/localStorage/legacy/localStorage.legacy';

import useServerHealth from '@/hooks/useServerHealth';

import 'moment/dist/locale/en-gb';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/nl';

import App from '../App';
import ServerDown from '../ServerDown';
import Start from '../Start/Start';

const Auth = () => {
  const auth = useAuth();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);

  useEffect(() => {
    if (
      !hasAuthParams() &&
      !auth.isAuthenticated &&
      !auth.activeNavigator &&
      !auth.isLoading &&
      !hasTriedSignin
    ) {
      setHasTriedSignin(true);
      auth.signinRedirect();
    } else if (auth.isAuthenticated && auth.user) {
      const { profile } = auth.user;

      i18next.changeLanguage(profile.locale);
      moment.locale(profile.locale === LanguageCode.EN ? 'en-gb' : profile.locale);
      API.postSyncUser();
    }
  }, [auth, hasTriedSignin]);

  // Temporarily disabled as it causes not yet explainable issues at times
  // const { serverDown } = useServerHealth();

  if (auth.error) {
    return <div>Oops... {auth.error.message}</div>;
  }

  if (!auth.isAuthenticated || !auth.user) return <Start />;

  migrateLegacyLocalStorage(auth.user.profile.sub);

  return <App />;
};

export default Auth;
